var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Emit, Prop } from "vue-property-decorator";
var AwaitCasetype = /** @class */ (function (_super) {
    __extends(AwaitCasetype, _super);
    function AwaitCasetype() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.caseModel = {
            caseType: "",
        };
        return _this;
    }
    AwaitCasetype.prototype.close = function () { };
    AwaitCasetype.prototype.confirm = function () {
        this.close();
    };
    AwaitCasetype.prototype.refresh = function () {
        this.caseModel.caseType = this.caseTypeShow;
    };
    AwaitCasetype.prototype.datas = function () {
        return this.caseModel.caseType;
    };
    __decorate([
        Prop()
    ], AwaitCasetype.prototype, "caseTypeShow", void 0);
    __decorate([
        Emit("close")
    ], AwaitCasetype.prototype, "close", null);
    __decorate([
        Emit("confirm")
    ], AwaitCasetype.prototype, "confirm", null);
    AwaitCasetype = __decorate([
        Component({
            components: {},
        })
    ], AwaitCasetype);
    return AwaitCasetype;
}(Vue));
export default AwaitCasetype;
